import React from "react";
import "./Banner.css";
import { FaTaxi, FaHandshake, FaCarSide } from "react-icons/fa";

const Banner = () => {
  return (
    <section className="banner container-fluid">
      <div className="overlay">
        <h1 className="banner-title">
          Moving Lives With <span>Thaani</span>
        </h1>

        <div className="banner-content-boc">
          <div className="banner-box">
            <div className="banner-item">
              <FaTaxi size={32} />
              <p>Book a ride</p>
            </div>
            <div className="banner-item">
              <FaHandshake size={32} />
              <p>Be a Franchise</p>
            </div>
            <div className="banner-item">
              <FaCarSide size={32} />
              <p>Attach your vehicle</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
